import { Column, LinearProgress, Row } from 'components/Blocks';
import { Coin } from 'components/DecorativeIcons';
import { RedeemButton } from 'components/Rewards';
import { appConfig } from 'config/app';
import { useUser } from 'providers/Auth';

import { useLang } from 'locale';
import { cn } from 'styles';

export function MobileIncentiveTab() {
  const { t } = useLang();
  const { activeIncentive, firstName } = useUser();

  const progress = Math.min((activeIncentive / appConfig.minimumRedemption) * 100, 100);
  const canRedeem = activeIncentive >= appConfig.minimumRedemption;

  const points = (
    <span className={cn('whitespace-nowrap', canRedeem ? 'text-warning' : 'text-foreground-light')}>
      <strong className="text-lg font-semibold">{activeIncentive}</strong>

      <span className="font-medium"> / {appConfig.minimumRedemption}</span>
    </span>
  );

  return (
    <Column
      className="fixed bottom-0 left-0 right-0 z-10 border-t bg-grad-grayish-3 px-4 py-3"
      gap="2"
    >
      <Row justifyContent="space-between">
        <strong>{firstName}</strong>

        {canRedeem ? (
          points
        ) : (
          <Row>
            <Coin size={20} />

            <span className="-ml-2 text-sm font-semibold text-foreground">{t('points')}</span>
          </Row>
        )}
      </Row>

      <Row>
        <LinearProgress
          value={progress}
          trackClassName="bg-grad-gold"
          className="h-5 border"
          rounded
        >
          <span className="absolute right-1.5 top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-white" />
        </LinearProgress>

        {canRedeem ? (
          <RedeemButton className="rounded-full disabled:cursor-crosshair disabled:bg-muted-foreground" />
        ) : (
          points
        )}
      </Row>
    </Column>
  );
}
